"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostAgreementDelete = void 0;
const Base_1 = require("./Base");
exports.PostAgreementDelete = {
    url: Base_1.URL_BASE + "/AgreementDelete",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostAgreementDelete.js.map